module.exports = __webpack_public_path__ + "img/public/SiteIcons/searchIcon.svg?c4a917fc";